// Native Shopify AJAX Cart & Drawer Manager
(function() {
  'use strict';

  var STORAGE_KEY_MODE = 'nidra:payment_mode';
  var PREPAID_CODE = window.ShopifyTheme?.settings?.prepaid_code || 'PREPAID10';
  var PREPAID_RATE = (window.ShopifyTheme?.settings?.prepaid_rate || 10) / 100;

  function formatMoney(amountInCents) {
    var rupees = Math.round(amountInCents / 100);
    return '₹' + rupees.toLocaleString('en-IN');
  }

  var NidraCart = {
    cart: null,
    paymentMode: localStorage.getItem(STORAGE_KEY_MODE) || 'prepaid',
    consentChecked: true,
    initialized: false,

    init: function() {
      if (this.initialized) return;
      this.initialized = true;
      this.bindEvents();
      this.fetch();

      // Auto-open if visitor landed on /cart
      var path = window.location.pathname.replace(/\/+$/, '') || '/';
      if (path === '/cart') {
        var self = this;
        setTimeout(function() {
          self.open();
        }, 150);
      }
    },

    open: function() {
      var drawer = document.getElementById('CartDrawer');
      var panel = document.getElementById('CartDrawerPanel');
      if (drawer && panel) {
        drawer.style.display = 'block';
        drawer.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function() {
          panel.style.transform = 'translateX(0)';
        });
        document.body.style.overflow = 'hidden';
        if (typeof window.clarity === 'function') {
          window.clarity('event', 'cart_drawer_opened');
        }
      }
    },

    close: function() {
      var drawer = document.getElementById('CartDrawer');
      var panel = document.getElementById('CartDrawerPanel');
      if (drawer && panel) {
        panel.style.transform = 'translateX(100%)';
        drawer.setAttribute('aria-hidden', 'true');
        setTimeout(function() {
          drawer.style.display = 'none';
        }, 400);
        document.body.style.overflow = '';
      }
    },

    fetch: function() {
      var self = this;
      var cartUrl = (window.ShopifyTheme && window.ShopifyTheme.routes && window.ShopifyTheme.routes.cart_url) ? window.ShopifyTheme.routes.cart_url : '/cart';
      return fetch(cartUrl + '.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          self.cart = cart;
          self.render();
          return cart;
        })
        .catch(function(err) {
          console.error('[NidraCart] Error fetching cart', err);
        });
    },

    add: function(params) {
      var self = this;
      if (typeof params.payOnline === 'boolean') {
        self.paymentMode = params.payOnline ? 'prepaid' : 'cod';
        localStorage.setItem(STORAGE_KEY_MODE, self.paymentMode);
      }

      var body = {
        id: params.id,
        quantity: params.quantity || 1
      };

      var addUrl = (window.ShopifyTheme && window.ShopifyTheme.routes && window.ShopifyTheme.routes.cart_add_url) ? window.ShopifyTheme.routes.cart_add_url : '/cart/add';

      return fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Add to cart HTTP ' + res.status);
        return res.json();
      })
      .then(function() {
        return self.fetch();
      })
      .then(function() {
        if (params.openDrawer !== false) {
          self.open();
        }
      })
      .catch(function(err) {
        console.error('[NidraCart] Add to cart failed', err);
        throw err;
      });
    },

    change: function(key, quantity) {
      var self = this;
      var changeUrl = (window.ShopifyTheme && window.ShopifyTheme.routes && window.ShopifyTheme.routes.cart_change_url) ? window.ShopifyTheme.routes.cart_change_url : '/cart/change';

      return fetch(changeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Change quantity HTTP ' + res.status);
        return res.json();
      })
      .then(function(cart) {
        self.cart = cart;
        self.render();
        return cart;
      })
      .catch(function(err) {
        console.error('[NidraCart] Change quantity failed', err);
      });
    },

    setPaymentMode: function(mode) {
      this.paymentMode = mode;
      localStorage.setItem(STORAGE_KEY_MODE, mode);
      if (typeof window.clarity === 'function') {
        window.clarity('event', mode === 'prepaid' ? 'cart_prepaid_selected' : 'cart_cod_selected');
        window.clarity('set', 'cart_payment_mode', mode);
      }
      this.render();
    },

    render: function() {
      var cart = this.cart;
      if (!cart) return;

      // 1. Update Header Badges across entire document
      var badges = document.querySelectorAll('#CartCount, #CartBadgeCount, .cart-count-badge');
      badges.forEach(function(badge) {
        badge.textContent = cart.item_count;
        if (cart.item_count > 0) {
          badge.style.display = badge.classList.contains('cart-count-badge') ? 'grid' : 'inline-flex';
        } else {
          badge.style.display = 'none';
        }
      });

      // Also update aria-label on header buttons
      var cartBtns = document.querySelectorAll('#HeaderCartBtn, #CartDrawerOpenBtn, .bag-btn');
      cartBtns.forEach(function(btn) {
        btn.setAttribute('aria-label', 'Cart, ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items'));
      });

      var drawerCount = document.getElementById('CartDrawerItemCount');
      if (drawerCount) {
        drawerCount.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items');
      }

      // 2. Empty / Full visibility
      var emptyEl = document.getElementById('CartDrawerEmpty');
      var listEl = document.getElementById('CartDrawerItemsList');
      var footerEl = document.getElementById('CartDrawerFooter');

      if (cart.item_count === 0) {
        if (emptyEl) emptyEl.style.display = 'flex';
        if (listEl) listEl.style.display = 'none';
        if (footerEl) footerEl.style.display = 'none';
        return;
      }

      if (emptyEl) emptyEl.style.display = 'none';
      if (listEl) listEl.style.display = 'flex';
      if (footerEl) footerEl.style.display = 'block';

      // 3. Render line items
      if (listEl) {
        listEl.innerHTML = '';
        cart.items.forEach(function(item) {
          var li = document.createElement('li');
          li.style.display = 'flex';
          li.style.gap = '16px';
          li.style.paddingBottom = '16px';
          li.style.borderBottom = '1px solid var(--color-line)';

          var imgHtml = item.image
            ? '<img src="' + item.image + '" alt="' + (item.title || '') + '" style="width: 72px; height: 72px; object-fit: cover; border-radius: var(--radius); border: 1px solid var(--color-line);">'
            : '<div style="width: 72px; height: 72px; background: var(--color-panel-2); border-radius: var(--radius);"></div>';

          var itemPrice = item.final_line_price || item.original_line_price;

          li.innerHTML =
            imgHtml +
            '<div style="flex: 1; min-width: 0; display: flex; flex-direction: column;">' +
              '<div style="display: flex; justify-content: space-between; gap: 8px;">' +
                '<div>' +
                  '<p style="font-size: 13.5px; font-weight: 600; color: var(--color-paper); line-height: 1.2;">' + item.product_title + '</p>' +
                  '<p style="font-size: 11px; color: var(--color-paper-dim); margin-top: 3px;">' + (item.variant_title || '') + '</p>' +
                '</div>' +
                '<p style="font-size: 13px; font-weight: 500; color: var(--color-paper); flex-shrink: 0;">' + formatMoney(itemPrice) + '</p>' +
              '</div>' +
              '<div style="margin-top: auto; padding-top: 10px; display: flex; align-items: center; justify-content: space-between;">' +
                '<div style="display: flex; align-items: center; border: 1px solid var(--color-line-strong); border-radius: var(--radius);">' +
                  '<button type="button" class="qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity" style="width: 28px; height: 28px; background: transparent; border: none; cursor: pointer; display: grid; place-items: center; color: var(--color-paper);">-</button>' +
                  '<span style="width: 24px; text-align: center; font-size: 12.5px; color: var(--color-paper);">' + item.quantity + '</span>' +
                  '<button type="button" class="qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity" style="width: 28px; height: 28px; background: transparent; border: none; cursor: pointer; display: grid; place-items: center; color: var(--color-paper);">+</button>' +
                '</div>' +
                '<button type="button" class="remove-btn" data-key="' + item.key + '" style="background: transparent; border: none; font-size: 11px; color: var(--color-paper-dim); text-decoration: underline; cursor: pointer;">Remove</button>' +
              '</div>' +
            '</div>';

          listEl.appendChild(li);
        });
      }

      // 4. Update Payment Mode Button Styles
      var prepaidBtn = document.getElementById('CartPayModePrepaid');
      var codBtn = document.getElementById('CartPayModeCod');
      var isPrepaid = (this.paymentMode === 'prepaid');

      if (prepaidBtn) {
        prepaidBtn.style.borderColor = isPrepaid ? 'var(--color-brass-bright)' : 'var(--color-line-strong)';
        prepaidBtn.style.background = isPrepaid ? 'var(--color-panel-2)' : 'var(--color-panel)';
      }
      if (codBtn) {
        codBtn.style.borderColor = !isPrepaid ? 'var(--color-brass-bright)' : 'var(--color-line-strong)';
        codBtn.style.background = !isPrepaid ? 'var(--color-panel-2)' : 'var(--color-panel)';
      }

      // 5. Calculations (Subtotal, Discount, Total)
      var originalSubtotal = cart.original_total_price;
      var discountAmount = isPrepaid ? Math.round(originalSubtotal * PREPAID_RATE) : 0;
      var totalPayable = Math.max(0, originalSubtotal - discountAmount);
      var prepaidPayable = Math.max(0, originalSubtotal - Math.round(originalSubtotal * PREPAID_RATE));

      var subtotalEl = document.getElementById('CartDrawerSubtotal');
      var discountRowEl = document.getElementById('CartDrawerDiscountRow');
      var discountAmountEl = document.getElementById('CartDrawerDiscountAmount');
      var checkoutBtn = document.getElementById('CartDrawerCheckoutBtn');
      var promoAppliedBox = document.getElementById('CartPromoApplied');
      var promoForm = document.getElementById('CartPromoForm');
      var prepaidPriceTag = document.getElementById('CartPrepaidPriceTag');
      var codPriceTag = document.getElementById('CartCodPriceTag');
      var prepaidNudge = document.getElementById('CartPrepaidNudge');

      if (subtotalEl) subtotalEl.textContent = formatMoney(originalSubtotal);
      if (prepaidPriceTag) prepaidPriceTag.textContent = formatMoney(prepaidPayable) + ' total';
      if (codPriceTag) codPriceTag.textContent = formatMoney(originalSubtotal) + ' total';

      if (prepaidNudge) {
        prepaidNudge.innerHTML = isPrepaid
          ? '<span style="color: var(--color-brass-bright); font-weight: 600;">✓ 10% prepaid savings</span> applied automatically for online payment.'
          : '<span style="color: var(--color-paper); font-weight: 500;">Cash on Delivery:</span> Standard catalog price of ' + formatMoney(originalSubtotal) + ' payable upon arrival.';
      }

      if (isPrepaid) {
        if (discountRowEl) discountRowEl.style.display = 'flex';
        if (discountAmountEl) discountAmountEl.textContent = '−' + formatMoney(discountAmount);
        if (promoAppliedBox) promoAppliedBox.style.display = 'flex';
        if (promoForm) promoForm.style.display = 'none';
      } else {
        if (discountRowEl) discountRowEl.style.display = 'none';
        if (promoAppliedBox) promoAppliedBox.style.display = 'none';
        if (promoForm) promoForm.style.display = 'flex';
      }

      if (checkoutBtn) {
        checkoutBtn.textContent = 'Checkout · ' + formatMoney(totalPayable) + (isPrepaid ? ' (Prepaid)' : ' (COD)');
        checkoutBtn.disabled = !this.consentChecked;
      }
    },

    bindEvents: function() {
      var self = this;

      // Delegated Global Header & Cart Trigger Listener (Works across all pages, buttons, links)
      document.addEventListener('click', function(e) {
        var cartTrigger = e.target.closest('#HeaderCartBtn, #CartDrawerOpenBtn, .bag-btn, [data-cart-drawer-trigger], a[href="/cart"], a[href$="/cart"]');
        if (cartTrigger) {
          e.preventDefault();
          self.open();
          return;
        }

        // Close on backdrop or close buttons
        if (e.target.closest('#CartDrawerCloseBtn, #CartDrawerBackdrop, #CartContinueBrowsing')) {
          e.preventDefault();
          self.close();
          return;
        }

        // Quantity buttons delegation
        var qtyBtn = e.target.closest('.qty-btn');
        if (qtyBtn) {
          e.preventDefault();
          var key = qtyBtn.getAttribute('data-key');
          var qty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
          if (key) self.change(key, qty);
          return;
        }

        // Remove button delegation
        var rmBtn = e.target.closest('.remove-btn');
        if (rmBtn) {
          e.preventDefault();
          var key2 = rmBtn.getAttribute('data-key');
          if (typeof window.clarity === 'function') {
            window.clarity('event', 'cart_item_removed');
          }
          if (key2) self.change(key2, 0);
          return;
        }
      });

      // Escape key to close
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          self.close();
        }
      });

      // Payment preference toggle buttons
      var prepaidBtn = document.getElementById('CartPayModePrepaid');
      var codBtn = document.getElementById('CartPayModeCod');

      if (prepaidBtn) {
        prepaidBtn.addEventListener('click', function() {
          self.setPaymentMode('prepaid');
        });
      }
      if (codBtn) {
        codBtn.addEventListener('click', function() {
          self.setPaymentMode('cod');
        });
      }

      // Consent Checkbox
      var consentCb = document.getElementById('CartConsentCheckbox');
      var checkoutBtn = document.getElementById('CartDrawerCheckoutBtn');

      if (consentCb) {
        consentCb.addEventListener('change', function(e) {
          self.consentChecked = e.target.checked;
          if (checkoutBtn) checkoutBtn.disabled = !self.consentChecked;
        });
      }

      // Checkout Button Action -> Direct to /checkout
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function() {
          if (!self.consentChecked) return;
          if (typeof window.clarity === 'function') {
            window.clarity('event', 'checkout_button_clicked');
            window.clarity('set', 'checkout_mode', self.paymentMode);
          }
          var checkoutUrl = (self.paymentMode === 'prepaid') ? '/checkout?discount=' + encodeURIComponent(PREPAID_CODE) : '/checkout';
          window.location.href = checkoutUrl;
        });
      }

      // Promo Code Remove
      var rmDiscountBtn = document.getElementById('CartRemoveDiscountBtn');
      if (rmDiscountBtn) {
        rmDiscountBtn.addEventListener('click', function() {
          self.setPaymentMode('cod');
        });
      }

      // Promo Form Submit
      var promoForm = document.getElementById('CartPromoForm');
      var promoInput = document.getElementById('CartPromoInput');
      if (promoForm && promoInput) {
        promoForm.addEventListener('submit', function(e) {
          e.preventDefault();
          var code = promoInput.value.trim().toUpperCase();
          var updateUrl = (window.ShopifyTheme && window.ShopifyTheme.routes && window.ShopifyTheme.routes.cart_update_url) ? window.ShopifyTheme.routes.cart_update_url : '/cart/update';
          if (code === PREPAID_CODE) {
            self.setPaymentMode('prepaid');
          } else {
            fetch(updateUrl + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: code })
            }).then(function() {
              self.fetch();
            });
          }
        });
      }
    }
  };

  window.NidraCart = NidraCart;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      NidraCart.init();
    });
  } else {
    NidraCart.init();
  }
})();
